import {
  Box,
  Button,
  ButtonBase,
  Card,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { RootState } from "config/store";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { listItemCategory } from "shared/network/category.api";
import CategorySelectDialog from "./CategorySelectDialog";
import { getFileByPath } from "shared/network/file.api";
import { ItemCategory } from "shared/types";

const SellingFormCategoryItem = ({
  category,
  selectedCategory,
  setSelectedCategory,
}: {
  category: ItemCategory;
  selectedCategory: ItemCategory;
  setSelectedCategory: any;
}) => {
  const { selectedRelTenant } = useSelector((state: RootState) => state.authentication);
  const tenant = selectedRelTenant?.tenant;

  const profilePicQuery = useQuery(
    ["deliveryDeliveryItemDialog", category?.imageLink],
    async () => {
      if (category?.imageLink) {
        const { data } = await getFileByPath(category?.imageLink, tenant?.id);
        const file = new Blob([data], { type: "image/jpeg" });
        const fileURL = URL.createObjectURL(file);
        return fileURL;
      }
      return Promise.reject();
    },
    { enabled: !!category?.imageLink },
  );

  return (
    <Card
      onClick={() => {
        if (selectedCategory?.id === category.id) {
          setSelectedCategory(null);
        } else {
          setSelectedCategory(category);
        }
      }}
      style={{
        flex: "1 1 calc(20% - 20px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: 16,
        cursor: "pointer",
        boxShadow:
          selectedCategory?.id === category.id
            ? "0 4px 24px 0 rgba(25, 118, 210, 0.18)"
            : "0px 4px 10px rgba(0, 0, 0, 0.08)",
        border:
          selectedCategory?.id === category.id ? "2.5px solid #1976d2" : "1.5px solid #e0e0e0",
        background:
          selectedCategory?.id === category.id
            ? "linear-gradient(90deg, #e3f2fd 60%, #fffde7 100%)"
            : "#fff",
        transition: "box-shadow 0.2s, border 0.2s, background 0.2s",
        position: "relative",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          background: "#f5f7fa",
          marginBottom: 8,
          boxShadow: "0 2px 8px 0 rgba(25, 118, 210, 0.06)",
          overflow: "hidden",
          border:
            selectedCategory?.id === category.id ? "2px solid #1976d2" : "1.5px solid #e0e0e0",
          transition: "border 0.2s",
        }}
      >
        {profilePicQuery.isLoading ? (
          <Skeleton variant="circle" width={60} height={60} />
        ) : profilePicQuery.data ? (
          <img
            src={profilePicQuery.data}
            alt={category.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : (
          <Box
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ color: "#bdbdbd", fontSize: 32 }}
          >
            <span role="img" aria-label="category">
              📦
            </span>
          </Box>
        )}
      </Box>
      <Typography
        variant="subtitle1"
        style={{
          fontWeight: 700,
          fontSize: 14,
          color: selectedCategory?.id === category.id ? "#1976d2" : "#222",
          textAlign: "center",
          marginTop: 4,
          marginBottom: 0,
          fontFamily: "Montserrat, sans-serif",
          letterSpacing: 0.2,
          lineHeight: 1.2,
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={category.name}
      >
        {category.name}
      </Typography>
    </Card>
  );
};

export default SellingFormCategoryItem;
